<h1>New Location</h1>

<form [formGroup]="newLocationForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="newLocationForm.touched && newLocationForm.invalid">
        <ul>
            <li *ngIf="newLocationForm.touched && newLocationForm.controls['locationName'].invalid">Location Name can't be empty.</li>
            <li *ngIf="newLocationForm.touched && newLocationForm.controls['branchId'].invalid">Branch can't be empty.</li>
            <li *ngIf="newLocationForm.touched && newLocationForm.controls['cost'].invalid">Cost can't be empty.</li>
            <li *ngIf="newLocationForm.touched && newLocationForm.errors?.exists">Location already exists.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="locationName">Location Name</label>
        <input
            id="locationName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="locationName"
            [ngClass]="{ 'input-validation-error': newLocationForm.touched && newLocationForm.controls['locationName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="branchId">Branch</label>
        <ng-select
            [items]="branches"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': newLocationForm.touched && newLocationForm.controls['branchId'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="cost">Cost</label>
        <input
            id="cost"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="cost"
            digitOnly
            [decimal]="true"
            [ngClass]="{ 'input-validation-error': newLocationForm.touched && newLocationForm.controls['cost'].invalid }"
        />
    </div>
    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="isPublished" formControlName="isPublished" class="custom-control-input" />
            <label for="isPublished" class="custom-control-label cursor-pointer">is Published</label>
        </div>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Create</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
